import { render, staticRenderFns } from "./ModalAddCarrinhoClone.vue?vue&type=template&id=15b0ffe4&scoped=true"
import script from "./ModalAddCarrinhoClone.vue?vue&type=script&lang=js"
export * from "./ModalAddCarrinhoClone.vue?vue&type=script&lang=js"
import style0 from "./ModalAddCarrinhoClone.vue?vue&type=style&index=0&id=15b0ffe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b0ffe4",
  null
  
)

export default component.exports